export function isMeetingResponse(itemClass: string | undefined): boolean {
    return !!(itemClass && itemClass.match(/^ipm\.schedule\.meeting\.resp/i));
}
